export const fetchCsrfCookie = async (
  baseUrl: string = window.runConfig.backendUrl
): Promise<void> => {
  const response = await fetch(`${baseUrl}/sanctum/csrf-cookie`, {
    credentials: 'include',
  });
  await response.text();
};
